import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { validateUrlFormat } from '@utils/urls';

import { Typography } from '../Typography';
import { TAPLinkProps } from './types';

export const APLink = ({
  textKey,
  text,
  redirectUrl,
  route,
  newTab = false,
  className,
}: TAPLinkProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const linkText = textKey ? t(textKey) : text;

  const onRedirect = () => {
    if (route) {
      navigate(route);
      return;
    }
    if (redirectUrl) {
      window.open(validateUrlFormat(redirectUrl), newTab ? '_blank' : '_self');
    }
  };

  return (
    <span onClick={onRedirect}>
      <Typography
        text={linkText}
        className={`text-[#059986] cursor-pointer ${className}`}
        weight={500}
      />
    </span>
  );
};
